<script>
import Multiselect from 'vue-multiselect'
import VueIconPicker from '@components/vue-icon-picker';
import { appSectionsMethods } from '@state/helpers'

let _ = require('lodash')

export default {
    name: 'AppSectionsCreateForm',
    components: { Multiselect, 'vue-icon-loader': VueIconPicker },
    props: {
        onformsubmit: {
            type: Function,
            required: true
            },
        validator: {
            type: Object,
            required: true
            },
        form: {
            type: Object,
            required: true
            }
    },
    data() {
        return {
            icon: {name:"", type:"fontawesome",color:"#000000"},
            appSectionsOptions: [],
            appSectionsOptionsCache: [],
            appSectionsOptionsMounted: false,
            loadingAppSectionsOptions: false
        }
    },
    watch: {
        icon: function (value) {
            this.form.icon_name = value ? value.name : ""
        },
    },
    mounted(){
        if (this.form.icon_name){
            this.icon.name = this.form.icon_name
        }
        this.populateAppSectionsOptions()
    },
    methods: {
        ...appSectionsMethods,
        populateAppSectionsOptions(searchQuery){
            let context = this
            context.loadingAppSectionsOptions = true
            let reqParams = context.$select_params(searchQuery)
            const promise = context.fetchAppSections(reqParams)
            return promise.then(data => {
                let listOptions = []
                data.results.forEach(opt => {
                    // let parentTreeName = ''
                    // if (opt.parent_tree.length - 1){
                    //     for (let i = 0; i < opt.parent_tree.length; i++) {
                    //         if(i !== (opt.parent_tree.length - 1)){
                    //             const el = opt.parent_tree[i];
                    //             parentTreeName = parentTreeName.concat(`${el.name} > `)
                    //         }
                    //     }
                    // }
                    // parentTreeName = parentTreeName.concat(opt.name)
                    // listOptions.push({
                    //     'url': opt.url,
                    //     'name': opt.name,
                    //     parentTreeName
                    // })
                    listOptions.push({
                        _id: opt._id,
                        name: opt.name
                    })
                });
                context.appSectionsOptions = listOptions
                context.appSectionsOptionsMounted = true
                context.loadingAppSectionsOptions = false
            }).catch(error => {
                context.$axios_error_noty(error, context)
                context.appSectionsOptionsMounted = true
                context.loadingAppSectionsOptions = false
            })
        },
        asyncFindAppSections: _.debounce(function (searchQuery) {
            this.populateAppSectionsOptions(searchQuery)
        }, 600),

        labelOfAppSectionsOptions(opt){
            console.log(opt)
            let appSectionsOptionsFounded = this.appSectionsOptions.find(x => x._id=== opt)
            if (!appSectionsOptionsFounded){
                let cacheFounded = this.appSectionsOptionsCache.find(x => x._id=== opt)
                console.log(cacheFounded)
                return  cacheFounded ? cacheFounded : this.appSectionsOptionsMounted ? `Not found in options: ${opt}`: ''
            }else{
                if (this.form.parent === opt){ // === When is a single option select
                    if (!this.appSectionsOptionsCache.find(x => x._id=== opt)){
                        this.appSectionsOptionsCache.push(appSectionsOptionsFounded)
                    }
                } 
                return appSectionsOptionsFounded.name
            }
        },

    }
}
</script>
<template>
    <b-form  id="form" @submit="onformsubmit" >
        <form-wrapper :validator="validator ">
        <div>
            <form-summary/>
        </div>
        <form-group name="name" label="Name">
            <b-form-input
                v-model="form.name"
                slot-scope="{ attrs, listeners }"
                v-bind="attrs"
                v-on="listeners"
            /> 
        </form-group>  
        <form-group name="path" label="Path">
            <b-form-input
                v-model="form.path"
                slot-scope="{ attrs, listeners }"
                v-bind="attrs"
                v-on="listeners"
            /> 
        </form-group>
        <form-group name="hover_text" label="Hover text">
            <b-form-input
                v-model="form.hover_text"
                slot-scope="{ attrs, listeners }"
                v-bind="attrs"
                v-on="listeners"
            /> 
        </form-group>
        <vue-icon-loader v-model="icon" input-name="icon_name" label="icon" height="300px"/>
        <form-group name="app-sections-select" label="Is it a submenu of?">
            <Multiselect
                id="app-sections-select"
                v-model="form.parent"
                :multiple="false"
                :options="appSectionsOptions.map(x => x._id)" 
                :custom-label="opt => labelOfAppSectionsOptions(opt)"
                :loading="loadingAppSectionsOptions"
                :internal-search="false"
                @search-change="asyncFindAppSections">
            </Multiselect>
        </form-group>
        <form-group>
            <b-form-checkbox
                v-model="form.app_permission"
                :value="true"
                :unchecked-value="false"
            >
                It requires a permit ?
            </b-form-checkbox>
        </form-group>
        <!-- <form-group>
            <b-form-checkbox
                v-model="form.admin_required"
                :value="true"
                :unchecked-value="false"
            >
                Requires to be an admin?
            </b-form-checkbox>
        </form-group> -->
        </form-wrapper>
    </b-form>
</template>